import { MyTeamTab } from '@/src/components/my-team/my-team-tabs/MyTeamTabs'
import { useTabNavigation } from '@/src/hooks/use-tab-navigation/useTabNavigation'

export const useTeamNavigation = () =>
  useTabNavigation<MyTeamTab>({
    basePath: '/my-team',
    validTabs: ['vendors', 'diagnoses'],
    defaultTab: 'vendors',
  })
